<section class="hd-profile-info">
  <div class="hd-profile-info__header">
    <h3 class="hd-profile-info__title">{{ title() }}</h3>
    @if (hasOwnProfile()) {
      <button type="button" class="hd-profile-info__jump-to-own"
              (click)="scrollToOwn()">
        {{ jumpToOwnLabel() }}
      </button>
    }
  </div>

  <markdown class="hd-profile-info__markdown" [src]="generalUrl()" />

  @if (hasOwnProfile()) {
    <div class="hd-profile-info__own">
      <div class="hd-profile-info__own-head">
        <span class="hd-profile-info__own-label">{{ ownLabel() }}</span>
        <button type="button" class="hd-profile-info__show-all-toggle"
                [class.is-active]="showAllProfiles()"
                [attr.aria-pressed]="showAllProfiles()"
                (click)="toggleShowAllProfiles()">
          {{ profilesToggleLabel() }}
        </button>
      </div>
      <div class="hd-profile-info__own-chips">
        @for (chip of ownChips(); track chip.targetKey) {
          <button type="button" class="hd-profile-info__own-chip"
                  (click)="scrollTo(chip.targetKey)">
            {{ chip.label }}
          </button>
        }
      </div>
    </div>
  }

  @for (section of visibleProfileSections(); track section.key) {
    <section class="hd-profile-info__section" [attr.data-profile-key]="section.key">
      <header class="hd-profile-info__section-header">
        <h4 class="hd-profile-info__section-title">{{ section.label }}</h4>
        @if (section.subtitle) {
          <span class="hd-profile-info__section-subtitle">{{ section.subtitle }}</span>
        }
        @if (section.isOwn) {
          <span class="hd-profile-info__own-badges">
            <span class="hd-profile-info__own-badge">{{ section.ownBadge }}</span>
          </span>
        }
      </header>
      <markdown class="hd-profile-info__markdown" [src]="section.url" />
    </section>
  }

  <div class="hd-profile-info__roles-header">
    <h3 class="hd-profile-info__roles-title">{{ rolesTitle() }}</h3>
    @if (hasOwnProfile()) {
      <button type="button" class="hd-profile-info__show-all-toggle"
              [class.is-active]="showAllRoleLines()"
              [attr.aria-pressed]="showAllRoleLines()"
              (click)="toggleShowAllRoleLines()">
        {{ rolesToggleLabel() }}
      </button>
    }
  </div>

  <markdown class="hd-profile-info__markdown" [src]="rolesGeneralUrl()" />

  @for (section of visibleRolesLineSections(); track section.line) {
    <section class="hd-profile-info__section" [attr.data-roles-line]="section.line">
      <header class="hd-profile-info__section-header">
        <h4 class="hd-profile-info__section-title">{{ section.label }}</h4>
        @if (section.subtitle) {
          <span class="hd-profile-info__section-subtitle">{{ section.subtitle }}</span>
        }
        @if (section.ownBadges.length > 0) {
          <span class="hd-profile-info__own-badges">
            @for (badge of section.ownBadges; track badge) {
              <span class="hd-profile-info__own-badge">{{ badge }}</span>
            }
          </span>
        }
      </header>
      <markdown class="hd-profile-info__markdown" [src]="section.url" />
    </section>
  }
</section>
